import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "core-js/modules/esnext.iterator.some.js";
import { computed, onMounted, ref, watch, nextTick, inject, toRefs } from "vue";
import { useRouter, useRoute } from "vue-router";
import { languageService, UtilityService, gaService } from '@/utils';
import { languageIdEnum } from "@/enums/plugins/i18n";
import { ApiQueryOrderByEnum, ApiQueryTargetTypeEnum, SpeakerTypeEnum, videoTypeEnum } from "@/enums/api/index";
import { getVideoDetail, postAddHistory } from "@/api/index";
import Breadcrumb from "@/components/modules/breadcrumb.vue";
import { useHead } from '@vueuse/head';
import YTPlayer from 'yt-player';
import { languageCodeToName } from '../plugins/language-code-name';
export default {
  name: "videoDetail",
  props: {
    category: {
      type: Array,
      required: false
    },
    autoplay: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const {
      category,
      autoplay
    } = toRefs(props);
    const router = useRouter();
    const route = useRoute();
    let player;
    const mappingRouterName = ref({
      home: "homeExplorer",
      webinar: "",
      masterClass: ""
    });
    const levelGroup = ["lEVEL_FOUNDATIONALl", "lEVEL_MEDIUM", "lEVEL_ADVANCED"];
    const sortType = {
      latest: ApiQueryOrderByEnum.LATEST,
      oldest: ApiQueryOrderByEnum.OLDEST,
      relevance: ApiQueryOrderByEnum.RELEVANCE
    };
    const currentType = ref("");
    const videoData = ref(null);
    const {
      getLanguage,
      getLocaleMessege,
      getLanguagePath
    } = languageService;
    const currentLang = computed(() => getLanguage());
    let langId = computed(() => languageIdEnum[currentLang.value.toUpperCase()]);
    const loading = ref(true);
    const isApiError = ref(false);
    let routeNameExcludeLang;
    const breadcrumbData = ref(null);
    const {
      recordProductDetailImpression,
      recordProductClick,
      recordProductImpression
    } = gaService;
    const {
      getDescriptionAndTimecode,
      textToHtml,
      updateBookmarkStatusProcess,
      videoType,
      preprocessData
    } = UtilityService;
    const resourceListStatus = ref({
      showOnlineManual: false,
      showDownloadFiles: false,
      showTutorialArticles: false
    });
    const apiDataType = computed(() => {
      return currentType.value === videoType.skillPath.type ? videoTypeEnum.TUTORIAL : videoType[currentType.value].value;
    });
    const store = inject('store');
    useHead({
      title: computed(() => videoData.value ? videoData.value.title + ' - ' + getLocaleMessege("COMMON").REALLUSION_COURSES : null)
    });

    //API
    const getApiParams = () => {
      if (currentType.value === videoType.tutorial.type) {
        const getLevel = () => {
          const level = route.query.level.split(",").filter(item => item != "");
          if (level.length == 0 || level.length == levelGroup.length) {
            return "";
          } else {
            return level.reduce((data, level) => {
              let index = levelGroup.findIndex(groupItem => groupItem == level);
              if (index != -1) {
                data.push(index + 1);
              }
              return data;
            }, []).join(",");
          }
        };
        const hasSearch = route.query.sort && sortType[route.query.sort.toLowerCase()] != undefined ? true : false;
        return {
          "urlName": decodeURIComponent(route.query.v),
          "category": routeNameExcludeLang.filter(item => item != "").map(item => decodeURIComponent(item)),
          "lang": langId.value,
          "targetType": ApiQueryTargetTypeEnum.ONLY_VIDEO,
          "level": hasSearch ? route.query.level ? getLevel() : "" : null,
          //Library跳到detail，選的level ，all 帶 ""，沒有用到帶null
          "productVersion": hasSearch ? route.query.version ? route.query.version : "" : null,
          //Library跳到detail，選的version，all 帶 ""，沒有用到帶null
          "keyword": hasSearch ? route.query.alltags ? decodeURIComponent(route.query.alltags) : "" : null,
          //Library跳到detail，選的keyword，沒有用到帶null
          "orderBy": hasSearch ? sortType[route.query.sort.toLowerCase()] : null,
          // Latest(0)、Oldest(1)、Relevance(2)， 從home連過來帶null
          "productFamily": hasSearch ? route.query.product ? decodeURIComponent(route.query.product) : "" : null //all 帶 "" ，沒有用到帶null
        };
      } else if (currentType.value === videoType.master.type) {
        return {
          "urlName": decodeURIComponent(route.query.v),
          "category": routeNameExcludeLang.filter(item => item != "").map(item => decodeURIComponent(item)),
          "lang": langId.value,
          "targetType": ApiQueryTargetTypeEnum.ONLY_VIDEO
        };
      } else if (currentType.value === videoType.webinar.type) {
        return {
          "urlName": decodeURIComponent(route.query.v),
          "searchType": 0
        };
      } else if (currentType.value === videoType.skillPath.type) {
        return {
          "urlName": decodeURIComponent(route.query.v),
          "category": category.value
        };
      } else {
        return null;
      }
    };
    const getVideoData = async () => {
      routeNameExcludeLang = route.path.toLocaleLowerCase().replace(new RegExp(currentLang.value + "/"), "").split("/").slice(1);
      currentType.value = videoType.tutorial.type;
      for (const key in videoType) {
        if (routeNameExcludeLang[0] == videoType[key].category) {
          currentType.value = videoType[key].type;
        }
      }
      loading.value = true;
      getVideoDetail(videoType[currentType.value].apiPath, getApiParams()).then(data => {
        switch (currentType.value) {
          case videoType.tutorial.type:
          case videoType.master.type:
          case videoType.skillPath.type:
            videoData.value = preprocessData(data);
            break;
          case videoType.webinar.type:
            videoData.value = preprocessData(data[0]);
            videoData.value.locationBar = [{
              "name": "Webinar",
              "urlName": "webinar"
            }, {
              "name": "Archive",
              "urlName": "archive"
            }, {
              "name": videoData.value.title,
              "urlName": videoData.value.urlName
            }];
            videoData.value.category = ['webinar', "archive"];
            videoData.value.date = videoData.value.date.replace(/\//g, "-");
            break;
        }
        if (videoData.value) {
          checkUrlPath();
          const {
            timecode,
            description
          } = getDescriptionAndTimecode(videoData.value.description);
          videoData.value.description = textToHtml(description);
          videoData.value.timecode = timecode;
          breadcrumbData.value = processBreadcrumbData(getLanguagePath(), videoData.value.locationBar);
          nextTick(() => {
            initVideoPlayer(getYoutubeVideoID(videoData.value.link));
          });
          if (!autoplay.value) {
            window.scrollTo({
              top: 0,
              behavior: "instant"
            });
          }
          recordProductDetailImpression(videoData.value, videoType[currentType.value].category + "-detail");
          if (store.member.states.loginInfo?.data?.login) {
            postAddHistory({
              "id": videoData.value.id,
              "dataType": apiDataType.value
            }).then(data => {}).catch(err => {
              console.log(err);
            });
          }
        } else {
          isApiError.value = true;
        }
        loading.value = false;
      }, res => {
        loading.value = false;
        isApiError.value = true;
        videoData.value = null;
      }).catch(error => {
        isApiError.value = true;
        loading.value = false;
        videoData.value = null;
        console.log(error);
      });
    };
    const initVideoPlayer = videoID => {
      player = new YTPlayer("#videoPlayer", {
        related: false //show related videos from the same channel
      });
      player.load(videoID);
      if (autoplay.value) {
        player.on('cued', () => {
          player.play();
        });
      }
      player.on('ended', () => {
        emit('videoEnded', decodeURIComponent(route.query.v));
      });
    };
    onMounted(async () => {
      if (route.query.v) {
        await getVideoData();
      }
    });
    watch([() => route.query, () => route.params], ([query, params]) => {
      if (query.v) {
        getVideoData();
      }
    });
    const getYoutubeVideoID = link => {
      var objExp = new RegExp(/^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})/);
      return link.match(objExp) ? link.match(objExp)[1] : "";
    };
    const getVersion = function (type, data) {
      if (!type && (!data.productVersion.length || !data.productName)) {
        return "";
      }
      if (type == videoType.tutorial.type || type == videoType.master.type || type == videoType.skillPath.type) {
        return getLocaleMessege("COMMON").VERSION + ": " + UtilityService.groupVersion(data.productVersion).map(item => {
          return item.productFamily + ' ' + item.versions.join('/');
        }).join(", ");
      } else if (type == videoType.webinar.type) {
        return getLocaleMessege("COMMON").VERSION + ": " + data.productName;
      } else {
        return "";
      }
    };
    const getPrice = function (price) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });
      return price != 0 ? formatter.format(price) : getLocaleMessege("VIDEO_DETAIL").FREE;
    };
    const getOutline = function (outline) {
      return outline.reduce((string, item) => {
        return string + `<li>${item}</li>`;
      }, "<ul style='margin: 0px'>") + "</ul>";
    };
    const getVideoTime = function (videoLength) {
      if (videoLength <= 0) {
        return "";
      }
      let hours = parseInt(videoLength / 3600);
      let minutes = parseInt(videoLength % 3600 / 60);
      let seconds = videoLength % 60;
      let time = [hours, minutes, seconds].reduce((all, item) => {
        if (all.length) {
          all.push(item < 10 ? "0" + item : item);
        } else if (item > 0) {
          all.push(item);
        }
        return all;
      }, []);
      if (time.length < 2) {
        time.unshift(0);
      }
      return time.join(":");
    };
    const bookmarkChange = function (newBookmarkStatus, id, isRelevance) {
      updateBookmarkStatusProcess(id, newBookmarkStatus, apiDataType.value).then(() => {
        if (isRelevance) {
          const foundIndex = videoData.value.relevance.findIndex(element => element.id == id);
          videoData.value.relevance[foundIndex].isBookmarked = newBookmarkStatus;
        } else {
          videoData.value.isBookmarked = newBookmarkStatus;
        }
      }).catch(error => {
        console.log(error);
      });
    };
    const clickImage = function (item, index) {
      router.push({
        path: "/" + (currentLang.value != "en" ? currentLang.value + "/" : "") + item.category.join("/"),
        query: Object.assign({}, route.query, {
          v: item.urlName
        })
      });
      recordProductClick(item, videoType[currentType.value].category + "-relevance", index);
    };
    const checkUrlPath = () => {
      if (currentType.value === videoType.tutorial.type || currentType.value === videoType.master.type) {
        const isMatchPath = [...videoData.value.alsoDisplay, videoData.value.category].some(category => route.path.includes(category.join("/")));
        if (!videoData.value.category || !isMatchPath) {
          // router.push("/");
        }
      } else if (currentType.value === videoType.webinar.type) {
        if (!route.path.includes("/webinar/archive")) {
          router.push("/");
        }
      }
    };
    const changeVideoTime = time => {
      const videoTime = time.split(":").reverse().reduce((total, time, index) => {
        total += parseInt(time) * 60 ** index;
        return total;
      }, 0);
      player.seek(videoTime);
      player.play();
      $('html,body').animate({
        scrollTop: $(".video-detail-container").offset().top - 60
      }, 500);
    };
    const processBreadcrumbData = (path, locationBar) => {
      const data = locationBar.map(({
        name,
        urlName
      }) => {
        path += urlName + "/";
        return {
          name,
          path
        };
      });
      if (currentType.value === videoType.tutorial.type) {
        data.shift();
      }
      return data;
    };
    const handleThumbnailError = e => {
      const element = e.srcElement;
      element.src = require('@/assets/images/Speaker_Default_Thumbanil.jpg');
      element.onerror = null;
    };
    return {
      route,
      mappingRouterName,
      currentType,
      videoData,
      loading,
      getVersion,
      getPrice,
      getOutline,
      getVideoTime,
      bookmarkChange,
      clickImage,
      changeVideoTime,
      breadcrumbData,
      isApiError,
      recordProductImpression,
      videoType,
      currentLang,
      languageCodeToName,
      resourceListStatus,
      preprocessData,
      textToHtml,
      SpeakerTypeEnum,
      handleThumbnailError
    };
  },
  components: {
    Breadcrumb
  }
};